<template>
  <div class="wrapper">
    <notifications></notifications>
    <side-bar
      :logo="
        setting_image && setting_image.logo_sgv && setting_image.logo_sgv.value ?
        setting_image.logo_sgv.value : '/img/brand/top-logo.png'
      "
      shortTitle="Crédito Inteligente"
      title=""
    >
      <template slot="links">
        <sidebar-item
          v-for="(group, key) in groups"
          :key="key"
          :menu="!!group.routes.length"
          :link="group"
        >
          <sidebar-item
            v-for="(route, index) in group.routes"
            :key="route.name + index"
            :link="route"
          >
          </sidebar-item>
        </sidebar-item>
      </template>
    </side-bar>
    <div class="main-content" style="opacity: 0.9999;">
      <dashboard-navbar :type="$route.meta.navbarType"></dashboard-navbar>
      <div @click="$sidebar.displaySidebar(false)">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <div>
            <dashboard-header color="light" style="background-position-y: center; background-color: #F6F9FC;">
              <slot name="header"></slot>
            </dashboard-header>
            <div
              class="container-fluid"
              style="min-height: calc(100vh - 80px);"
            >
              <slot name="layout"></slot>
            </div>
          </div>
        </fade-transition>
      </div>
      <!-- <content-footer v-if="!$route.meta.hideFooter"></content-footer> -->
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

import DashboardHeader from "@/layouts/DashboardHeader";
import DashboardNavbar from "@/layouts/DashboardNavbar";
import DashboardContent from "@/layouts/Content";
import SidebarItem from "@/components/SidebarPlugin/SidebarItem";
import { FadeTransition } from "vue2-transitions";
import PageTitle from "@/layouts/PageTitle";

export default {
  components: {
    SidebarItem,
    DashboardHeader,
    DashboardNavbar,
    DashboardContent,
    FadeTransition,
    PageTitle,
  },
  data() {
    return {
      routesAfter: [],
      groups: [],
      dashboards: [],
    };
  },
  methods: {
    initScrollbar() {
      let isWindows = navigator.platform.startsWith("Win");
      if (isWindows) {
        initScrollbar("sidenav");
      }
    },
    initSidebarItems() {
      var groupsCRI =  Object.assign({}, this.$router.options.groupsCRI)
      var routesAfter = [];

      // init group routes
      for (let group in groupsCRI) {
        groupsCRI[group].routes = [];
      }

      this.$router.options.routes.forEach((route) => {
        if (!route.meta || !route.meta.permissions) return;
        // Filtering hidden routes
        if (route.meta && route.meta.hideFromSidenav) return;
        // Filtering cri routes
        if (!Object.keys(route.meta).includes('groupsCRI')) return;

        // Filtering unpermited routes
        if (
          !route.meta.permissions.find((controller) =>
            this.$can("any", controller)
          )
        )
          return;

        // Add to group routes
        if (route.meta.groupsCRI) {
          groupsCRI[route.meta.groupsCRI].routes.push(route);
        } else {
          routesAfter.push(route);
        }
      });

      // Filtering unpermited groups
      for (let group in groupsCRI) {
        if (!groupsCRI[group].permissions) continue;
        if (
          !groupsCRI[group].permissions.find((permission) =>
            this.$can("any", permission)
          )
        ) {
          delete groupsCRI[group];
        }
      }

      // this.routes = routes
      this.routesAfter = routesAfter;
      this.groups = groupsCRI;
    },
    initDashboards() {
      this.$http.secured
          .get('/api/v1/dashboards')
          .then(response => this.dashboards = response.data)
    },
  },
  mounted() {
    this.initScrollbar();
    this.initSidebarItems();
  },
  computed: {
    setting_image() {
      return this.$store.state.imageSettings || {}
    }
  },
};
</script>

<style lang="scss">
html {
  background-color: #fff;
}

.navbar.sidenav{
  overflow: hidden;

  &:hover {
    overflow-y: auto;
  }
}
</style>
